import React from "react";
import EvidenceCard from "./EvidenceCard";

const KEY = [
  { type: "string", label: "Red string", meaning: "built with this tool" },
  { type: "thread", label: "Dark thread", meaning: "shipped at this employer" },
  { type: "twine", label: "Gold twine", meaning: "leads back to the subject" },
];

export const BoardLegend = ({ className = "" }) => (
  <EvidenceCard variant="clipping" pin="black" rotate={1.2} className={`board-legend ${className}`} data-cursor="default">
    <p className="clipping-kicker">How to read this board</p>
    <ul className="board-legend-list">
      {KEY.map((item) => (
        <li key={item.type}>
          <svg className="board-legend-swatch" viewBox="0 0 44 10" aria-hidden="true">
            <path d="M2 4 Q 22 10 42 4" className={`connection-path is-${item.type}`} />
          </svg>
          <span>
            <strong>{item.label}</strong> — {item.meaning}
          </span>
        </li>
      ))}
    </ul>
    <p className="board-legend-foot">Click any pinned card to pull its file.</p>
  </EvidenceCard>
);

export default BoardLegend;
